declare const Reverb: any;

export function flashSuccess(msg: string) {
  Reverb.UI.flashSuccess(msg);
}

export function flashError(msg: string) {
  Reverb.UI.flashError(msg);
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/flash.ts